import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

const CRMLogin = () => {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("admin@forterealty.com");
  const [password, setPassword] = useState("ForteAdmin2026!");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => { if (user && user !== false) navigate("/crm"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) navigate("/crm");
    else setErr(r.error);
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center p-6 relative overflow-hidden" data-testid="crm-login-page">
      <img src="https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&q=85" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="relative w-full max-w-md bg-navy-light border border-white/10 p-10">
        <div className="mb-8">
          <div className="leading-none">
            <div className="font-display text-white text-2xl font-bold uppercase tracking-[0.18em]">Forte</div>
            <div className="font-display text-gold text-lg font-bold uppercase tracking-[0.32em] mt-1.5">Realty</div>
          </div>
          <div className="text-[10px] tracking-[0.25em] text-gold uppercase mt-3">Agent Portal · CRM</div>
        </div>
        <div className="overline text-gold flex items-center gap-2"><Lock className="w-3.5 h-3.5" /> Restricted Access</div>
        <h1 className="font-display text-3xl text-white mt-3">Sign in</h1>
        <p className="text-sm text-white/60 mt-2">Authorized agents, brokers, and administrators only.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="crm-login-form">
          <div>
            <label className="block text-xs text-white/60 uppercase tracking-widest mb-2">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full bg-transparent border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-gold" data-testid="crm-login-email" />
          </div>
          <div>
            <label className="block text-xs text-white/60 uppercase tracking-widest mb-2">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full bg-transparent border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-gold" data-testid="crm-login-password" />
          </div>
          {err && <div className="text-sm text-red-400" data-testid="crm-login-error">{err}</div>}
          <button disabled={busy} className="btn-gold w-full py-3" data-testid="crm-login-submit">{busy ? "Signing in…" : "Sign In"}</button>
        </form>

        <div className="mt-8 pt-6 border-t border-white/10 text-xs text-white/50 space-y-1">
          <div className="text-gold uppercase tracking-widest mb-2">Demo accounts</div>
          <div>admin@forterealty.com · ForteAdmin2026!</div>
          <div>broker@forterealty.com · Broker2026!</div>
          <div>agent@forterealty.com · Agent2026!</div>
        </div>
      </div>
    </div>
  );
};

export default CRMLogin;
